import {
  CHAVE_LOCAL, PREFERENCIAS_PADRAO, ehPreferenciasValidas, type PreferenciasA11y,
} from '../../shared/acessibilidade';

/**
 * Le e aplica as preferencias no <html>. O primeiro `aplicar` ja aconteceu no
 * script inline do index.html; este modulo cuida das mudancas em tempo de
 * execucao e do espelho em localStorage.
 *
 * Todo acesso a localStorage e envolvido em try/catch: em aba anonima ou com
 * dados de site bloqueados o acessor LANCA, e derrubar o app inteiro por causa
 * de uma preferencia visual seria trocar um problema pequeno por um total.
 */
export function lerLocal(): PreferenciasA11y {
  try {
    const bruto = localStorage.getItem(CHAVE_LOCAL);
    if (!bruto) return PREFERENCIAS_PADRAO;
    const v: unknown = JSON.parse(bruto);
    return ehPreferenciasValidas(v) ? v : PREFERENCIAS_PADRAO;
  } catch {
    return PREFERENCIAS_PADRAO;
  }
}

export function gravarLocal(p: PreferenciasA11y): void {
  try {
    localStorage.setItem(CHAVE_LOCAL, JSON.stringify(p));
  } catch {
    // Sem armazenamento: a preferencia vale para esta sessao e, se a pessoa
    // estiver logada, ja foi salva na conta.
  }
}

export function aplicar(p: PreferenciasA11y): void {
  const h = document.documentElement;
  h.dataset['contraste'] = p.contraste;
  h.dataset['fonte'] = p.fonte;
  h.dataset['movimento'] = p.movimento;
}

/** Avisa quem lê preferência fora do CSS (a voz do chat) que ela mudou. */
export const EVENTO_PREFERENCIAS = 'chamaum:a11y';

export function aplicarEGravar(p: PreferenciasA11y): void {
  aplicar(p);
  gravarLocal(p);
  window.dispatchEvent(new CustomEvent<PreferenciasA11y>(EVENTO_PREFERENCIAS, { detail: p }));
}
